import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ac-type-11-icon',
  templateUrl: './ac-type-11-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AcType11IconComponent {}
